<template>
  <div class="live-virtual-trainings-empty__section">
    <div class="live-virtual-trainings-empty__header">
      <LiveVirtualTrainingsEmpty class="live-virtual-trainings-empty__header-img" />
    </div>
    <div class="live-virtual-trainings-empty__title">
      Our Live Virtual Training schedule is currently empty.
    </div>
    <div class="live-virtual-trainings-empty__subtitle">
      Don't worry though, we're hard at work crafting new sessions to keep you on the cutting edge.
    </div>
  </div>
</template>

<script>
import LiveVirtualTrainingsEmpty from '@/assets/icons/live-virtual-training-empty.svg'

export default {
  name: 'LiveVirtualTrainingSectionEmpty',
  components: {
    LiveVirtualTrainingsEmpty: { ...LiveVirtualTrainingsEmpty, name: 'LiveVirtualTrainingsEmpty' },
  },
}
</script>

<style lang="scss">
.live-virtual-trainings-empty {
  &__section {
    text-align: center;
  }
  &__title {
    font-family: var(--font-medium);
    font-weight: 500;
    font-size: rem(18px);
    line-height: rem(24px);
    margin-bottom: 10px;
  }
  &__subtitle {
    font-family: var(--font-medium);
    font-weight: 450;
    font-size: rem(14px);
    line-height: rem(20px);
    color: var(--light-blue-gray);
    margin-bottom: 30px;
  }
}
</style>
